import styled from 'styled-components';
import { IImage } from '@belong/types';

const IMAGE_SIZE = {
  xs: { w: 230, h: 145 }
};

const getObjectFit = ({ contentType }): string => (contentType === 'svg' ? 'contain' : 'cover');
export const ImageWrapper = styled.div<Pick<IImage, 'contentType'>>`
  img,
  picture {
    display: block;
    margin: auto;
    width: ${IMAGE_SIZE.xs.w / 10}rem;
    height: ${IMAGE_SIZE.xs.h / 10}rem;
    object-fit: ${getObjectFit};
  }
`;
